// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--2TGku"};